import React from 'react'
import PropTypes from 'prop-types'
import { Outlet } from 'react-router-dom'

import { popupFactory, toastFactory } from '@/factories'
import { ImpersonationNotice } from '@/components/business/support-impersonation'

import Alert from '../Alert'
import GlobalListeners from '../components/GlobalListeners'

import ChatWidget from './Chat/ChatWidget/ChatWidget'
import AccountWarningModal from './AccountWarningModal/AccountWarningModal'

// This is a class-based component because the current
// version of hot reloading won't hot reload a stateless
// component at the top-level.
class App extends React.Component {
  render() {
    return (
      <>
        <popupFactory.PopupProvider />
        <toastFactory.ToastProvider />
        <ImpersonationNotice />
        <ChatWidget />
        <Alert />
        <GlobalListeners />
        <AccountWarningModal />
        <Outlet />
      </>
    )
  }
}

App.propTypes = {
  children: PropTypes.element,
}

export default App
